import { createSelector } from '@ngrx/store';
import { appSettingsState } from '../root';

export const getLoyaltyAppId = createSelector(
    appSettingsState,
    state => state.apiSettings?.data?.Id || null
);

